import { ReactComponent as RheinbahnLogoImageOnly } from '../../../../assets/img/rheinbahn-logo-image-only.svg';
import { ReactComponent as RheinbahnLogoTextOnly } from '../../../../assets/img/rheinbahn-logo-text-only.svg';
import styles from './logo.module.scss';

export interface LogoProps {
  anniversary?: boolean;
}

export const Logo = (props: LogoProps): JSX.Element => {
  if (props.anniversary) {
    return <div className={styles.LogoAnniversary} />;
  }

  return (
    <div className={styles.LogoContainer}>
      <RheinbahnLogoImageOnly />
      <RheinbahnLogoTextOnly className={styles.Text} />
    </div>
  );
};
